'use strict';

module.exports = (url = '') => {
  const urlParts = url.split('?');

  if (urlParts.length > 1) {
    urlParts[1] = `gifting=true&${urlParts[1]}`;
    url = urlParts.join('?');
  }

  return url;
};
